import React from 'react';
import VideoType1 from '../../video_sections/video_type_1';
import WeightLossWebinarParent from '../index';

export default function June292021({ home, updateAnswersAction }) {
  return (
    <div>
      <WeightLossWebinarParent
        home={home}
        updateAnswersAction={updateAnswersAction}
        title={'Post Weight-Loss Surgery Misconceptions'}
        photo={
          'https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/webinars/june-29-2021/webinarphoto.jpeg'
        }
        webinarDate={'June 29, 2021 9:00:00'}
        webinarDateText={['Tuesday, June 29th, 2021', '11:00 AM CT', '45 Minutes']}
        webinarTitleForDb={'June292021'}
        evergreenPage={'/webinar/june-29-2021/view'}
        googleCalendarLink={
          'https://calendar.google.com/calendar/u/0/r/eventedit?dates=20210629T160000Z/20210629T170000Z&text=Post+Weight-Loss+Surgery+Misconceptions&location=https://zoom.us/j/95400117287&details=Thinking+about+weight-loss+surgery?+Make+sure+you+know+all+the+facts+-+and+myths+-+about+the+procedure+and+what+to+expect+after.+%0A%0ABariatric+surgery+is+gaining+popularity,+yet+a+lot+of+patients+still+get+scared+to+go+through+with+the+procedure+and+receive+the+care+they+need+because+of+the+misconceptions+around+the+topic.%0A%0AIf+you%E2%80%99re+thinking+about+weight+loss+surgery,+you+will+want+to+listen+in+on+this+webinar+where+Dr.+Smith+will+debunk+the+most+common+myths+and+talk+through+the+information+you+need+before+making+any+decision.+We+will+also+be+joined+by+Dr.+Smith%E2%80%99s+recovered+patient+and+a+PatientPartner+mentor,+Ashley+Gonzalez,+who+lost+130+pounds+since+surgery+to+talk+about+her+journey,+address+the+experience+from+her+perspective+and+answer+questions.%0A%0AJoin+our+webinar+as+we+talk+through+the+following+post-surgery+misconceptions:%0A-+Bariatric+surgery+is+the+easy+way+out%0A-+You%E2%80%99ll+still+need+blood+pressure+medication+and+insulin%0A-+Recovery+is+painful+and+takes+too+long%0A-+Weight+regain+is+inevitable+and+there+is+nothing+you+can+do+about+it%0A-+You+don%E2%80%99t+have+to+make+any+dietary+changes+after+surgery%0A-+Personal+relationships+will+stay+the+same+after+surgery%0A%0A%0AAbout+Dr.+Smith:%0ADr.+Adam+Smith+fights+obesity+on+a+personal+and+professional+level.+He+is+not+just+a+bariatric+surgeon+but+also+a+patient.+After+watching+his+patients+and+their+success+with+the+LAP-BAND%C2%AE+system,+Dr.+Smith+chose+to+undergo+LAP-BAND%C2%AE+surgery+in+2002+to+aid+in+his+own+personal+weight+loss.+After+losing+100+pounds+himself,+Dr.+Smith+was+able+to+relate+to+patients+and+their+everyday+struggles.+This+knowledge+has+helped+him+develop+one+of+the+most+comprehensive+aftercare+programs+in+North+Texas.+Dr.+Smith+has+led+the+battle+on+many+different+fronts+by+standing+up+for+the+rights+of+the+obese+population.%0A%0A%0AVideo:+https://www.youtube.com/watch?v%3DBkB3pagjQPs&inf_contact_key=6984ee0d56919e88cbe389ae9775b668680f8914173f9191b1c0223e68310bb1&sf=true'
        }
        otherCalendarLink={
          'https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/webinars/june-29-2021/PostWeightLossSurgeryMisconceptions.ics'
        }
        wrapperClass={'center-bg-photo'}
        content={
          <>
            <h5 className='marg-top-30'>
              Thinking about weight-loss surgery? Make sure you know all the facts - and myths - about the procedure and
              what to expect after.
            </h5>
            <p className='marg-top-30'>
              Bariatric surgery is gaining popularity, yet a lot of patients still get scared to go through with the
              procedure and receive the care they need because of the misconceptions around the topic.
            </p>
            <p className='marg-top-20'>
              If you’re thinking about weight loss surgery, you will want to listen in on this webinar where Dr. Smith
              will debunk the most common myths and talk through the information you need before making any decision. We
              will also be joined by Dr. Smith’s recovered patient and a PatientPartner mentor, Ashley Gonzalez, who
              lost 130 pounds since surgery to talk about her journey, address the experience from her perspective and
              answer questions.
            </p>
            <h2 className='body-subheadline marg-top-40'>
              Join our webinar as we talk through the following post-surgery misconceptions:
            </h2>
            <ul className='marg-top-10'>
              <li>You’ll still need blood pressure medication and insulin</li>
              <li>Recovery is painful and takes too long</li>
              <li>Weight regain is inevitable and there is nothing you can do about it</li>
              <li>You don’t have to make any dietary changes after surgery</li>
              <li>Personal relationships will stay the same after surgery</li>
            </ul>
            <h2 className='body-subheadline marg-top-40'>About Dr. Smith:</h2>
            <div className='surgeon'>
              <div className='row marg-top-20 photo-wrap rs-bio-vid'>
                <VideoType1
                  bg={''}
                  videoLink={
                    'https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/surgeons/dr-adam-smith/PatientPartner+Dr.+Smith+PatientPartner+Video.mp4'
                  }
                  headline={`About Dr. Smith`}
                  gtm={'Webinar June 29 2021 Video'}
                />
              </div>
            </div>
            <p className='marg-top-20 marg-bottom-20'>
              Dr. Adam Smith fights obesity on a personal and professional level. He is not just a bariatric surgeon but
              also a patient. After watching his patients and their success with the LAP-BAND® system, Dr. Smith chose
              to undergo LAP-BAND® surgery in 2002 to aid in his own personal weight loss. After losing 100 pounds
              himself, Dr. Smith was able to relate to patients and their everyday struggles. This knowledge has helped
              him develop one of the most comprehensive aftercare programs in North Texas. Dr. Smith has led the battle
              on many different fronts by standing up for the rights of the obese population.
            </p>
            <button className='marg-top-20 send-it-final no-mobile'>Register now</button>
          </>
        }
      />
    </div>
  );
}
